module.exports = __webpack_public_path__ + "static/img/stay-up-to-date-2.1dfee4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stay-up-to-date-2.jpg
// module id = k6DM
// module chunks = 1